// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1Joh{text-align:center}._2fOT{padding:1.6rem 0}._2fOT img{margin-bottom:.8rem}", ""]);
// Exports
exports.locals = {
	"center": "_1Joh",
	"textWithImages": "_2fOT"
};
module.exports = exports;
